export const mergeFieldDependencies = <TRow>(
  ...dependencies: (keyof TRow | (keyof TRow)[] | undefined)[]
): (keyof TRow)[] =>
  Array.from(
    new Set(
      // ensure uniqueness
      dependencies.reduce<(keyof TRow)[]>((acc, dep) => {
        if (Array.isArray(dep)) {
          acc.push(...dep);
        } else if (dep !== undefined) {
          acc.push(dep);
        }
        return acc;
      }, []),
    ),
  );
